import React, { createContext, useContext, useState } from "react";
import type { OnboardingState } from "@/types/question";

interface SignupJourneyContextValue {
  onboardingState: OnboardingState | null;
  setOnboardingState: React.Dispatch<React.SetStateAction<OnboardingState | null>>;
  selectedAnswer: number | undefined;
  setSelectedAnswer: React.Dispatch<React.SetStateAction<number | undefined>>;
  selectedCheckboxAnswers: number[];
  setSelectedCheckboxAnswers: React.Dispatch<React.SetStateAction<number[]>>;
  freeTextAnswer: string;
  setFreeTextAnswer: React.Dispatch<React.SetStateAction<string>>;
  clearJourneyState: () => void;
}

const SignupJourneyContext = createContext<SignupJourneyContextValue | null>(null);

export const SignupJourneyProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [onboardingState, setOnboardingState] =
    useState<OnboardingState | null>(null);
  const [selectedAnswer, setSelectedAnswer] = useState<number | undefined>(
    undefined,
  );
  const [selectedCheckboxAnswers, setSelectedCheckboxAnswers] = useState<
    number[]
  >([]);
  const [freeTextAnswer, setFreeTextAnswer] = useState("");

  const clearJourneyState = () => {
    setOnboardingState(null);
    setSelectedAnswer(undefined);
    setSelectedCheckboxAnswers([]);
    setFreeTextAnswer("");
  };

  return (
    <SignupJourneyContext.Provider
      value={{
        onboardingState,
        setOnboardingState,
        selectedAnswer,
        setSelectedAnswer,
        selectedCheckboxAnswers,
        setSelectedCheckboxAnswers,
        freeTextAnswer,
        setFreeTextAnswer,
        clearJourneyState,
      }}
    >
      {children}
    </SignupJourneyContext.Provider>
  );
};

export const useSignupJourney = (): SignupJourneyContextValue => {
  const ctx = useContext(SignupJourneyContext);
  if (!ctx) {
    throw new Error(
      "useSignupJourney must be used inside <SignupJourneyProvider>",
    );
  }
  return ctx;
};
